/** SPA geçişlerinde tarayıcının eski scroll konumunu geri yüklemesini kapat. */
export function initManualScrollRestoration() {
  if (typeof window === 'undefined' || !('scrollRestoration' in window.history)) return;
  try {
    window.history.scrollRestoration = 'manual';
  } catch {
    /* ignore */
  }
}

/** Sayfa / filtre değişiminde tepeye sabitle (mega menü → katalog dahil). */
export function scrollPageToTop() {
  if (typeof window === 'undefined') return;
  const opts = { top: 0, left: 0, behavior: 'auto' };
  window.scrollTo(opts);
  requestAnimationFrame(() => {
    window.scrollTo(opts);
    requestAnimationFrame(() => window.scrollTo(opts));
  });
}

const HEADER_SCROLL_OFFSET_PX = 108;

/** Scroll to a homepage section (waits for lazy/deferred mounts). */
export function scrollToHomeSection(sectionId, { behavior = 'smooth' } = {}) {
  if (typeof window === 'undefined' || !sectionId) return;

  let attempts = 0;
  const maxAttempts = 50;
  const intervalMs = 100;

  const tryScroll = () => {
    const el = document.getElementById(sectionId);
    if (el) {
      const top =
        el.getBoundingClientRect().top + window.scrollY - HEADER_SCROLL_OFFSET_PX;
      window.scrollTo({ top: Math.max(0, top), left: 0, behavior });
      return;
    }
    attempts += 1;
    if (attempts < maxAttempts) {
      setTimeout(tryScroll, intervalMs);
    }
  };

  tryScroll();
}
